import { HttpClient } from '@angular/common/http';
import { forwardRef, Inject, resolveForwardRef } from '@angular/core';

class ConfigHttpLoader {
    constructor(http, endpoint = '/config.json') {
        this.http = http;
        this.endpoint = endpoint;
    }
    loadSettings() {
        return new Promise((resolve, reject) => {
            const http = resolveForwardRef(this.http);
            http.get(this.endpoint).subscribe(resolve, () => reject('Endpoint unreachable!'));
        });
    }
}
ConfigHttpLoader.ctorParameters = () => [
    { type: HttpClient, decorators: [{ type: Inject, args: [forwardRef(() => HttpClient),] }] },
    { type: String }
];

export { ConfigHttpLoader };

//# sourceMappingURL=ngx-config-http-loader.js.map